import LivePreviewHandler from '../schema/LivePreviewHandler';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { callEditorApi } from 'owa-editor/lib/utils/callApi';

export default function createLivePreviewHandler<T>(
    viewState: EditorViewState,
    onSelect: (value: T) => void
): LivePreviewHandler<T> {
    return {
        startPreview: (value: T) => {
            callEditorApi(viewState, 'startShadowEdit');
            onSelect(value);
        },
        stopPreview: () => {
            callEditorApi(viewState, 'stopShadowEdit');
        },
    };
}
